import React from "react";
import { useTranslation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import italyFlag from "../../../assets/flags/italy.png";
import franceFlag from "../../../assets/flags/france.png";
import { SupportedLanguage, supportedLanguages } from "../../../i18n/i18n";

const languageFlags: Record<SupportedLanguage, string> = {
  it: italyFlag,
  fr: franceFlag,
};

const languageLabels: Record<SupportedLanguage, string> = {
  it: "Italiano",
  fr: "Français",
};

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const currentLanguage = (
    supportedLanguages.includes(i18n.language as SupportedLanguage)
      ? i18n.language
      : "it"
  ) as SupportedLanguage;

  const handleClose = () => setAnchorEl(null);

  return (
    <div>
      <IconButton
        aria-label="change language"
        aria-controls="language-menu"
        aria-haspopup="true"
        style={{ color: "white" }}
        size="small"
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          setAnchorEl(event.currentTarget)
        }
      >
        <img
          src={languageFlags[currentLanguage]}
          alt={languageLabels[currentLanguage]}
          style={{ width: 22, height: 22, borderRadius: "50%" }}
        />
      </IconButton>
      <Menu
        id="language-menu"
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ border: "1px solid #d3d4d5" }}
      >
        {supportedLanguages.map((lng) => (
          <MenuItem
            key={"language-menu-" + lng}
            selected={lng === currentLanguage}
            onClick={() => {
              i18n.changeLanguage(lng);
              handleClose();
            }}
          >
            <ListItemIcon>
              <img
                src={languageFlags[lng]}
                alt={languageLabels[lng]}
                style={{ width: 20, height: 20, borderRadius: "50%" }}
              />
            </ListItemIcon>
            <ListItemText primary={languageLabels[lng]} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
